export default __webpack_public_path__ + "static/media/featured-audubon.253de171.webp";